/* unplugin-vue-components disabled */import { render } from "./navbar-profile.vue?vue&type=template&id=8320c92a&scoped=true"
import script from "./navbar-profile.vue?vue&type=script&setup=true&lang=js"
export * from "./navbar-profile.vue?vue&type=script&setup=true&lang=js"

import "./navbar-profile.vue?vue&type=style&index=0&id=8320c92a&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8320c92a"],['__file',"src/components/navbar/navbar-profile.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8320c92a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8320c92a', __exports__)) {
    api.reload('8320c92a', __exports__)
  }
  
  module.hot.accept("./navbar-profile.vue?vue&type=template&id=8320c92a&scoped=true", () => {
    api.rerender('8320c92a', render)
  })

}


export default __exports__